import React, { useMemo } from 'react';

import { Helmet } from 'react-helmet';

import DynamicWrapper from '../../components/DynamicWrapper/DynamicWrapper';
import CommunityHeader from '../../components/Header/CommunityHeader';
import { useAppSelector } from '../../shared/hooks';
// import { useAppSelector } from '../../shared/hooks';
import { ROUTES } from '../../types/routes';
import CommunityContent from './CommunityContent';

interface Props {}

const Community: React.FC<Props> = () => {
  const {
    hostMetadata: { appName },
  } = useAppSelector((state) => state.app);

  const content = useMemo(
    () => ({
      title: `${appName || 'TagMango'} - Community`,
      metaTitle: `${appName || 'TagMango'} - Community`,
      metaDescription: `Check your channel groups, channels, feed posts, messages and more.`,
    }),
    [appName],
  );

  return (
    <DynamicWrapper path={ROUTES.COMMUNITY}>
      <Helmet>
        <title>{content.title}</title>
        <meta name="title" content={content.metaTitle} />
        <meta name="description" content={content.metaDescription} />
        <meta
          name="keywords"
          content="dashboard, tagmango, influencers, influencer marketing, video shoutout, How to make money online, online skills, content, creator, Instagram creator, youtube creator, community, feed, messages, channel groups, channels"
        />
        <meta property="og:title" content={content.metaTitle} />
        <meta property="og:description" content={content.metaDescription} />
      </Helmet>

      <div className="feed__container">
        <CommunityHeader />
        <CommunityContent />
      </div>
    </DynamicWrapper>
  );
};

export default Community;
